import { cn } from "@gigpro/ui/tailwind/cn";
import { useIsAdmin } from "domains/auth";
import { useAtom } from "jotai";
import { useHasAnySupportOpsCapability } from "layouts/SuperAdminPanel/capabilities";
import { superAdminPanelAtom } from "services/atoms";

// EXPERIMENTAL: bright-blue "S" toggle opening the SuperAdmin panel, tucked under the Admin dropdown.
export function SuperAdminButton({ className }: Readonly<{ className?: string }>) {
  const isAdmin = useIsAdmin();
  const hasSupportOpsTool = useHasAnySupportOpsCapability();
  const [open, setOpen] = useAtom(superAdminPanelAtom);

  if (!isAdmin || !hasSupportOpsTool) return null;

  return (
    <button
      type="button"
      onClick={() => setOpen((prev) => !prev)}
      aria-label="Toggle SuperAdmin panel"
      aria-pressed={open}
      className={cn(
        "relative z-0 -ml-2 flex h-7 shrink-0 items-center justify-center rounded-l-none rounded-r-sm bg-info pr-2 pl-4 text-huge leading-none font-bold text-white italic transition-all duration-200 ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:opacity-90",
        open && "shadow-[inset_0_2px_5px_rgba(0,0,0,0.5)]",
        className,
      )}
    >
      S
    </button>
  );
}
